const Vouchers = () => {
    return (
        <>
            <h1>This is Vouchers Page</h1>
        </>
    );
};

export default Vouchers;
